import { View } from 'backbone';
import { Model } from 'backbone';
import listService      from 'ListService.js';
import selectFieldModal from 'common-views/SelectFieldModalView';
import nameTemplate from 'behaviors/properties/main/instance-name.ejs';

class MainInstanceNameView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #ValueOfAFieldButton'  : 'showValueFieldModal'
        };

        if(!this.model.get('ValueOfAField')){
            this.model.set('ValueOfAField','', {silent: true});
        }

        if (this.model.get('fieldId')) {
            const id = this.model.get('fieldId');
            const obj = listService.getObject( listService.cleanId(id) );
            if (obj) {
                this.model.set('ValueOfAField', obj.model.get('name'), {silent: true});
            }
            else {
                 const fieldName = listService.determineFieldName(id );
                 this.model.set('ValueOfAField', fieldName, {silent: true});
            }

        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }


    showValueFieldModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';

        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get("fieldId"), {silent:true});
        var sfModal = new selectFieldModal({model: sfModel});
        sfModal.render().then((selectedField)=>{
            this.model.set('fieldId', selectedField.id, {silent:true});
            this.model.set('ValueOfAField', selectedField.name);
        });
    }

    render() {
        this.$el.empty();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var option=  this.model.get('instanceName');
        if (this.model.get('instanceName')) {
            $("input[name=instanceName][value=" + option + "]").prop('checked', true);
            $('#'+option).attr('disabled', false);
            $('#'+option).attr('readOnly', false);
            if (option === 'ValueOfAField') {
                $('#ValueOfAFieldButton').attr('disabled', false);
                $('#ValueOfAField').attr('readOnly', true);
            }
        }

        this.delegateEvents();
        return this;
    }

}

export default MainInstanceNameView;
